import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import 'amfe-flexible'
import {  Message } from 'element-ui';
Vue.config.productionTip = false
Vue.prototype.$message = Message
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
